<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-2">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-list-alt text-white"></i>
          </div>
          <div class="header-text-container">
            <h5 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Pedido de Produção</h5>
            <p class="text-muted mb-0 small">Pesquisa e gestão de pedidos de produção</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-2">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-select v-model="tipoData" :options="opcoesTipoData" class="mx-1 border-0 bg-transparent" style="width: 180px" />
                    <cec-input-data ref="dt1" v-model="dt1" class="mx-1" input-class="border-0 bg-transparent" style="width: 130px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="dt2" v-model="dt2" class="mx-1" input-class="border-0 bg-transparent" style="width: 130px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white"  @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-3 pb-2">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row>
                    <b-col md="4">
                      <label class="small font-weight-bold text-muted mb-1">Solicitante</label>
                      <funcionario-dropdown 
                        v-model="responsavelId"
                        placeholder="Selecione o Solicitante"
                      />
                    </b-col>
                    <b-col md="4">
                      <label class="small font-weight-bold text-muted mb-1">Tipo Beneficiamento</label>
                      <tipo-beneficiamento-drop-down 
                        v-model="tipoBeneficiamentoId"
                        placeholder="Selecione o Tipo"
                      />
                    </b-col>
                    <b-col md="4">
                      <label class="small font-weight-bold text-muted mb-1">Situação</label>
                      <div class="d-flex flex-wrap gap-2 mt-1">
                        <b-form-checkbox v-model="situacoesSelecionadas" value="0" class="mr-2">Cancelado</b-form-checkbox>
                        <b-form-checkbox v-model="situacoesSelecionadas" value="1" class="mr-2">Em Cadastro</b-form-checkbox>
                        <b-form-checkbox v-model="situacoesSelecionadas" value="2" class="mr-2">Aguardando Coleta</b-form-checkbox>
                        <b-form-checkbox v-model="situacoesSelecionadas" value="3" class="mr-2">Coletando</b-form-checkbox>
                        <b-form-checkbox v-model="situacoesSelecionadas" value="4" class="mr-2">Concluido</b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>
    
      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <!-- Main table element -->
            <b-table 
                  class="mb-0 table-finance"
                  id="table-pedido-producao"
                  ref="tbl"
                  show-empty
                  empty-text="Informe o filtro para ver os pedidos"
                  :dark="isDark"
                  small
                  responsive 
                  :tbody-tr-class="rowClassSelecionado"
                  hover 
                  :sticky-header="stickyHeight"
                  @row-clicked="clicarLinha"
                  @row-dblclicked="onEdit"
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage">
              
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(LOTE)>
                <SetFilter label="Lote" v-model="filtros.LOTE" :options="opcoes.LOTE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO)>
                <SetFilter label="Entrada" v-model="filtros.SITUACAO" :options="opcoes.SITUACAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO_SAIDA)>
                <SetFilter label="Saída" v-model="filtros.SITUACAO_SAIDA" :options="opcoes.SITUACAO_SAIDA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(NOME_TIPO_BENEFICIAMENTO)>
                <SetFilter label="Tipo" v-model="filtros.NOME_TIPO_BENEFICIAMENTO" :options="opcoes.NOME_TIPO_BENEFICIAMENTO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(NOME_RESPONSAVEL)>
                <SetFilter label="Solicitante" v-model="filtros.NOME_RESPONSAVEL" :options="opcoes.NOME_RESPONSAVEL" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(SITUACAO)="item">
                <b-badge pill :variant="colorirSituacao(item.item.SITUACAO)">{{traduzirSituacao(item.item.SITUACAO)}}</b-badge>
              </template>

              <template #cell(SITUACAO_SAIDA)="item">
                <b-badge pill :variant="colorirSituacaoSaida(item.item.SITUACAO_SAIDA)">{{traduzirSituacaoSaida(item.item.SITUACAO_SAIDA)}}</b-badge>
              </template>

              <template #cell(DATA_CADASTRO)="item">
                {{ formatarData(item.item.DATA_CADASTRO) }}
              </template>

              <template #cell(DATA_PREVISAO)="item">
                {{ formatarData(item.item.DATA_PREVISAO) }}
              </template>

              <template #cell(DATA_ENTRADA_INICIO)="item">
                {{ formatarDataHora(item.item.DATA_ENTRADA_INICIO) }}
              </template>

              <template #cell(DATA_ENTRADA_TERMINO)="item">
                {{ formatarDataHora(item.item.DATA_ENTRADA_TERMINO) }}
              </template>

              <template #cell(DATA_SAIDA_INICIO)="item">
                {{ formatarDataHora(item.item.DATA_SAIDA_INICIO) }}
              </template>

              <template #cell(DATA_SAIDA_TERMINO)="item">
                {{ formatarDataHora(item.item.DATA_SAIDA_TERMINO) }}
              </template>

              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button v-if="String(item.item.SITUACAO_SAIDA).trim() === '3'" type="button" @click.stop.prevent="onReabrirTerminalSaida(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Reabrir Saída" v-b-tooltip.hover>
                    <i class="fa fa-unlock"></i>
                  </b-button>
                  <b-button v-if="String(item.item.SITUACAO).trim() === '4'" type="button" @click.stop.prevent="onReabrirTerminalEntrada(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Reabrir Entrada" v-b-tooltip.hover>
                    <i class="fa fa-unlock"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalRastreabilidade(item.item)" variant="soft-warning" pill class="btn-icon-only shadow-sm" title="Rastreabilidade do Lote" v-b-tooltip.hover>
                    <i class="fa fa-history"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalInfo(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Mais Detalhes" v-b-tooltip.hover>
                    <i class="fa fa-info"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td class="font-weight-bold">Total: ({{ itensFiltrados.length }})</b-td>
                  <b-td colspan="13"></b-td>
                </b-tr>
              </template>
             
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal Detalhes -->
    <b-modal 
      id="modal-info" 
      hide-header 
      hide-footer 
      size="xl"
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
    >
      <div v-if="modalDetalhes" class="modal-premium-wrapper">
        <!-- Header Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
             style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-info-circle text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Detalhes do Pedido de Produção</h5>
                <small class="text-white opacity-75">Informações detalhadas de entrada e saída de produtos</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-info')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4">
          <!-- Info Bar -->
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
              <b-row align-v="center">
                  <b-col md="4">
                      <small class="modal-label-premium">Pedido / Lote</small>
                      <h5 class="mb-0 font-weight-bold text-dark">#{{ modalDetalhes.ID }} - {{ modalDetalhes.LOTE }}</h5>
                  </b-col>
                  <b-col md="4" class="border-left">
                      <small class="modal-label-premium">Status Entrada</small>
                      <div>
                        <b-badge pill :variant="colorirSituacao(modalDetalhes.SITUACAO)" class="px-3 py-1">
                          {{ traduzirSituacao(modalDetalhes.SITUACAO) }}
                        </b-badge>
                      </div>
                  </b-col>
                  <b-col md="4" class="border-left">
                      <small class="modal-label-premium">Status Saída</small>
                      <div>
                        <b-badge pill :variant="colorirSituacaoSaida(modalDetalhes.SITUACAO_SAIDA)" class="px-3 py-1">
                          {{ traduzirSituacaoSaida(modalDetalhes.SITUACAO_SAIDA) }}
                        </b-badge>
                      </div>
                  </b-col>
              </b-row>
          </div>

          <!-- Seção 1: Resumo -->
          <div class="modal-section-title mb-3">
              <i class="fa fa-list-ul mr-2 text-primary"></i> Resumo de Insumos (Entrada)
          </div>
          <div class="bg-white rounded border shadow-xs mb-4 overflow-hidden">
            <b-table 
              :items="etiquetasEntradaResumo" 
              :fields="fieldsResumo" 
              small 
              hover 
              responsive
              class="mb-0 table-details-premium"
            >
              <template #cell(PECAS_ATENDIDO)="data">
                <div class="d-flex align-items-center">
                  <div :class="data.item.ICONE === 1 ? 'bg-warning' : 'bg-success'" class="rounded-circle mr-2" style="width: 8px; height: 8px;"></div>
                  <span :class="data.item.ICONE === 1 ? 'text-warning' : 'text-success'" class="font-weight-bold small">
                    {{ data.item.ICONE === 1 ? 'Faltando' : 'Fechado' }} ({{ data.value }})
                  </span>
                </div>
              </template>
            </b-table>
          </div>

          <b-row>
            <!-- Seção 2: Detalhe Entrada -->
            <b-col lg="6">
              <div class="modal-section-title mb-3 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="fa fa-barcode mr-2 text-info"></i> Detalhe de Etiquetas (Entrada)
                  </div>
                  <b-button-group size="sm">
                    <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarExcelDetalhe(etiquetasEntrada, 'Entrada')" v-b-tooltip.hover title="Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarHtmlDetalhe(etiquetasEntrada, 'Entrada')" v-b-tooltip.hover title="Imprimir">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="text-muted p-0" @click="exportarCsvDetalhe(etiquetasEntrada, 'Entrada')" v-b-tooltip.hover title="CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                  </b-button-group>
              </div>
              <div class="bg-white rounded border shadow-xs mb-4 overflow-hidden">
                <b-table 
                  :items="etiquetasEntrada" 
                  :fields="fieldsEtiquetas" 
                  small 
                  hover 
                  responsive
                  sticky-header="350px"
                  class="mb-0 table-details-premium"
                >
                  <template #custom-foot>
                    <b-tr class="bg-light font-weight-bold">
                      <b-td colspan="5" class="text-right">TOTAIS:</b-td>
                      <b-td class="text-right">{{ totalEntradaPeso.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</b-td>
                      <b-td class="text-right">{{ totalEntradaPecas }}</b-td>
                    </b-tr>
                  </template>
                </b-table>
              </div>
            </b-col>

            <!-- Seção 3: Detalhe Saída -->
            <b-col lg="6">
              <div class="modal-section-title mb-3 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="fa fa-check-circle mr-2 text-success"></i> Produtos Beneficiados (Saída)
                  </div>
                  <b-button-group size="sm">
                    <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarExcelDetalhe(etiquetasSaida, 'Saida')" v-b-tooltip.hover title="Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarHtmlDetalhe(etiquetasSaida, 'Saida')" v-b-tooltip.hover title="Imprimir">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="text-muted p-0" @click="exportarCsvDetalhe(etiquetasSaida, 'Saida')" v-b-tooltip.hover title="CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                  </b-button-group>
              </div>
              <div class="bg-white rounded border shadow-xs mb-4 overflow-hidden">
                <b-table 
                  :items="etiquetasSaida" 
                  :fields="fieldsEtiquetas" 
                  small 
                  hover 
                  responsive
                  sticky-header="350px"
                  class="mb-0 table-details-premium"
                >
                  <template #custom-foot>
                    <b-tr class="bg-light font-weight-bold">
                      <b-td colspan="5" class="text-right">TOTAIS:</b-td>
                      <b-td class="text-right">{{ totalSaidaPeso.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}</b-td>
                      <b-td class="text-right">{{ totalSaidaPecas }}</b-td>
                    </b-tr>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Footer Customizado -->
        <div class="bg-light p-3 border-top d-flex justify-content-end">
          <b-button variant="secondary" class="px-4 font-weight-bold" @click="$bvModal.hide('modal-info')">
            FECHAR
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Rastreabilidade -->
    <b-modal 
      id="modal-rastreabilidade" 
      hide-header 
      hide-footer 
      size="xl"
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
    >
      <div v-if="modalRastreabilidade" class="modal-premium-wrapper">
        <!-- Header Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
             style="background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-history text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Rastreabilidade do Lote</h5>
                <small class="text-white opacity-75">Histórico de movimentação dos produtos do pedido #{{ modalRastreabilidade.ID }}</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-rastreabilidade')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4">
          <!-- Info Bar -->
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
              <b-row align-v="center">
                  <b-col md="6">
                      <small class="modal-label-premium">Pedido / Lote</small>
                      <h5 class="mb-0 font-weight-bold text-dark">#{{ modalRastreabilidade.ID }} - {{ modalRastreabilidade.LOTE }}</h5>
                  </b-col>
                  <b-col md="6" class="border-left">
                      <small class="modal-label-premium">Total de Movimentações</small>
                      <div class="d-flex align-items-center justify-content-between">
                        <h5 class="mb-0 font-weight-bold text-primary">{{ listaRastreabilidade.length }} registros</h5>
                        <b-button-group size="sm">
                          <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarExcelRastreabilidade()" v-b-tooltip.hover title="Excel">
                              <i class="fa fa-file-excel-o"></i>
                          </b-button>
                          <b-button variant="link" class="text-muted p-0 mr-2" @click="exportarHtmlRastreabilidade()" v-b-tooltip.hover title="Imprimir">
                              <i class="fa fa-print"></i>
                          </b-button>
                          <b-button variant="link" class="text-muted p-0" @click="exportarCsvRastreabilidade()" v-b-tooltip.hover title="CSV">
                              <i class="fa fa-file-text-o"></i>
                          </b-button>
                        </b-button-group>
                      </div>
                  </b-col>
              </b-row>
          </div>

          <div class="bg-white rounded border shadow-xs mb-4 overflow-hidden">
            <b-table 
              :items="listaRastreabilidade" 
              :fields="fieldsRastreabilidade" 
              small 
              hover 
              responsive
              sticky-header="500px"
              class="mb-0 table-details-premium"
            >
              <template #cell(SITUACAO)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <div v-if="data.value === 'E'" class="d-flex align-items-center">
                    <div class="status-dot bg-success mr-2"></div>
                    <span class="text-success font-weight-bold small">ENTROU</span>
                  </div>
                  <div v-else-if="data.value === 'S'" class="d-flex align-items-center">
                    <div class="status-dot bg-orange mr-2"></div>
                    <span class="text-orange font-weight-bold small">SAIU</span>
                  </div>
                  <div v-else-if="data.value === 'R'" class="d-flex align-items-center">
                    <div class="status-dot bg-danger mr-2"></div>
                    <span class="text-danger font-weight-bold small">EXCLUIDO</span>
                  </div>
                  <span v-else>{{ data.value }}</span>
                </div>
              </template>

              <template #cell(FORNECEDOR)="data">
                <span class="small text-muted">{{ data.value }}</span>
              </template>
            </b-table>
          </div>
        </div>

        <!-- Footer Customizado -->
        <div class="bg-light p-3 border-top d-flex justify-content-end">
          <b-button variant="secondary" class="px-4 font-weight-bold" @click="$bvModal.hide('modal-rastreabilidade')">
            FECHAR
          </b-button>
        </div>
      </div>
    </b-modal>

    <ModalAlertaResultadoGrande
      ref="modalConfirmacao"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
    />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import SetFilter from '@/components/Cec/SetFilter.vue'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import FuncionarioDropdown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import TipoBeneficiamentoDropDown from '@/views/componentes/dropdown/TipoBeneficiamentoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

export default {
  name: 'PedidoProducaoListagem',
  components: {
    FuncionarioDropdown,
    TipoBeneficiamentoDropDown,
    CecInputData,
    SetFilter,
    ModalAlertaResultadoGrande
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'LISTA',
    tblRef: 'tbl',
    useExternalPaging: true,
    preferVh: 68,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'LOTE', type: 'string', label: 'Lote' },
      { key: 'SITUACAO', type: 'string', label: 'Situação Entrada',
        labelMap: { '0': 'Cancelado', '1': 'Em Cadastro', '2': 'Aguardando Coleta', '3': 'Coletando', '4': 'Concluido' } },
      { key: 'SITUACAO_SAIDA', type: 'string', label: 'Situação Saída',
        labelMap: { '0': 'Cancelado', '1': 'Aguardando Coleta', '2': 'Encaixotando', '3': 'Produzido' } },
      { key: 'NOME_TIPO_BENEFICIAMENTO', type: 'string', label: 'Tipo' },
      { key: 'NOME_RESPONSAVEL', type: 'string', label: 'Solicitante' }
    ]
  })],
  data() {
    return {
      isBusy: false,
      filtro: {
        avancado: false
      },
      situacoesSelecionadas: ['0','1', '2', '3','4'],
      opcoesTipoData: [
        { value: 'E', text: 'Da Entrada Na Produção' },
        { value: 'S', text: 'Da Saída da Produção' },
        { value: 'C', text: 'Do Cadastro' },
        { value: 'N', text: 'Da Previsão de Entrada' }
      ],
      fields: [
        { key: 'ID', label: 'ID', sortable: true },
        { key: 'LOTE', label: 'Lote', sortable: true },
        { key: 'SITUACAO', label: 'Entrada', sortable: true },
        { key: 'SITUACAO_SAIDA', label: 'Saída', sortable: true },
        { key: 'NOME_TIPO_BENEFICIAMENTO', label: 'Tipo', sortable: true },
        { key: 'ITENS', label: 'Itens Ent.', sortable: true, tdClass: 'text-right' },
        { key: 'DATA_CADASTRO', label: 'Cadastro', sortable: true },
        { key: 'DATA_PREVISAO', label: 'Necessidade', sortable: true },
        { key: 'DATA_ENTRADA_INICIO', label: 'Entrada Início', sortable: true },
        { key: 'DATA_ENTRADA_TERMINO', label: 'Entrada Término', sortable: true },
        { key: 'DATA_SAIDA_INICIO', label: 'Produção Início', sortable: true },
        { key: 'DATA_SAIDA_TERMINO', label: 'Produção Término', sortable: true },
        { key: 'NOME_RESPONSAVEL', label: 'Solicitante', sortable: true },
        { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true },
        { key: 'actions', label: '', tdClass: 'text-right' }
      ],
      modalDetalhes: null,
      modalRastreabilidade: null,
      listaRastreabilidade: [],
      etiquetasEntradaResumo: [],
      etiquetasEntrada: [],
      etiquetasSaida: [],
      fieldsResumo: [
        { key: 'PRODUTO_ID', label: 'Produto ID' },
        { key: 'NOME_PRODUTO', label: 'Nome do Produto' },
        { key: 'PECAS_PEDIDO', label: 'Pedido', tdClass: 'text-right' },
        { key: 'PECAS', label: 'Entrada', tdClass: 'text-right' },
        { key: 'PECAS_ATENDIDO', label: 'Falta', tdClass: 'text-right' }
      ],
      fieldsEtiquetas: [
        { key: 'SEQUENCIA_EMBARQUE', label: 'Ordem' },
        { key: 'NOME_PRODUTO_CODIGO', label: 'Nome Produto' },
        { key: 'NUMERO_CAIXA', label: 'Caixa' },
        { key: 'CODIGO_BARRAS', label: 'Código Barras' },
        { key: 'CODIGO_INTERNO', label: 'Interno' },
        { key: 'PESO', label: 'Peso', tdClass: 'text-right', formatter: (v) => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '0,000' },
        { key: 'PECAS_CAIXA', label: 'Peças Caixa', tdClass: 'text-right' }
      ],
      fieldsRastreabilidade: [
        { key: 'ID', label: 'ID', sortable: true },
        { key: 'CODIGO', label: 'Produ', sortable: true },
        { key: 'DESCRICAO', label: 'Nome Produto', sortable: true },
        { key: 'CODIGO_BARRAS', label: 'Código Barras', sortable: true },
        { key: 'NUMERO_CAIXA', label: 'Número Caixa', sortable: true },
        { key: 'PESO', label: 'Peso', sortable: true, tdClass: 'text-right', formatter: (v) => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '0,000' },
        { key: 'PECAS_CAIXA', label: 'Peças Caixa', sortable: true, tdClass: 'text-right' },
        { key: 'FORNECEDOR', label: 'Destino', sortable: true },
        { key: 'SITUACAO', label: 'Estoque', sortable: true, tdClass: 'text-center' },
        { key: 'DATA_MOVIMENTO', label: 'Data', sortable: true, formatter: (v) => this.formatarData(v) },
        { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true }
      ],
      currentPage: 1,
      resultadoPendente: null,
      resultadoPendenteCount: 0
    }
  },
  computed: {
    ...mapGetters('pedidoProducao', ['LISTA', 'DT1', 'DT2', 'TIPO_DATA', 'RESPONSAVEL_ID', 'TIPO_BENEFICIAMENTO_ID', 'TIPO_SITUACAO', 'REGISTRO_SELECIONADO_ID']),
    ...mapGetters('tema', ['isDark']),
    dt1: {
      get() { return this.DT1 },
      set(val) { this.SET_DT1(val) }
    },
    dt2: {
      get() { return this.DT2 },
      set(val) { this.SET_DT2(val) }
    },
    tipoData: {
      get() { return this.TIPO_DATA },
      set(val) { this.SET_TIPO_DATA(val) }
    },
    responsavelId: {
      get() { return this.RESPONSAVEL_ID },
      set(val) { this.SET_RESPONSAVEL_ID(val) }
    },
    tipoBeneficiamentoId: {
      get() { return this.TIPO_BENEFICIAMENTO_ID },
      set(val) { this.SET_TIPO_BENEFICIAMENTO_ID(val) }
    },
    totalEntradaPeso() {
      return this.etiquetasEntrada.reduce((acc, item) => acc + (Number(item.PESO) || 0), 0)
    },
    totalEntradaPecas() {
      return this.etiquetasEntrada.reduce((acc, item) => acc + (Number(item.PECAS_CAIXA) || 0), 0)
    },
    totalSaidaPeso() {
      return this.etiquetasSaida.reduce((acc, item) => acc + (Number(item.PESO) || 0), 0)
    },
    totalSaidaPecas() {
      return this.etiquetasSaida.reduce((acc, item) => acc + (Number(item.PECAS_CAIXA) || 0), 0)
    }
  },
  watch: {
    situacoesSelecionadas(val) {
      this.SET_TIPO_SITUACAO(val.join('-'))
    }
  },
  methods: {
    ...mapMutations('pedidoProducao', ['SET_DT1', 'SET_DT2', 'SET_TIPO_DATA', 'SET_RESPONSAVEL_ID', 'SET_TIPO_BENEFICIAMENTO_ID', 'SET_TIPO_SITUACAO', 'SET_REGISTRO_SELECIONADO_ID', 'SET_LIMPAR']),
    ...mapActions('pedidoProducao', ['GERAR_LISTA']),
    
    async pesquisar() {
      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.GERAR_LISTA({ skipConfirmation: false })
        
        if (result && result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$store.commit('controle/setAguardando', false)
          this.$refs.modalConfirmacao.show()
          return
        }

        if (this.REGISTRO_SELECIONADO_ID) {
          this.$nextTick(() => {
            const el = document.querySelector('.table-primary')
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },
    confirmarCarregarResultadoGrande() {
      this.$refs.modalConfirmacao.hide()
      if (this.resultadoPendente) {
        this.$store.commit('pedidoProducao/SET_LISTA', this.resultadoPendente)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.$refs.modalConfirmacao.hide()
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    limpar() {
      this.SET_LIMPAR()
      this.situacoesSelecionadas = ['1', '2', '3']
      this.pesquisar()
    },
    novo() {
      this.$router.push('/producao/pedido/cadastro/add')
    },
    onEdit(item) {
      this.$router.push(`/producao/pedido/cadastro/edit/${item.ID}`)
    },
    clicarLinha(item) {
      this.SET_REGISTRO_SELECIONADO_ID(item.ID)
    },
    rowClassSelecionado(item, type) {
      if (!item || type !== 'row') return
      if (item.ID === this.REGISTRO_SELECIONADO_ID) return 'table-primary'
    },
    colorirSituacao(status) {
      const colors = {
        '0': 'danger',
        '1': 'warning',
        '2': 'primary',
        '3': 'orange',
        '4': 'success'
      }
      return colors[status] || 'secondary'
    },
    traduzirSituacao(status) {
      const labels = {
        '0': 'Cancelado',
        '1': 'Em Cadastro',
        '2': 'Aguardando Coleta',
        '3': 'Coletando',
        '4': 'Concluido'
      }
      return labels[status] || status
    },
    colorirSituacaoSaida(status) {
      const colors = {
        '0': 'danger',
        '1': 'primary',
        '2': 'orange',
        '3': 'success'
      }
      return colors[status] || 'secondary'
    },
    traduzirSituacaoSaida(status) {
      const labels = {
        '0': 'Cancelado',
        '1': 'Aguardando Coleta',
        '2': 'Encaixotando',
        '3': 'Produzido'
      }
      return labels[status] || status
    },
    formatarData(data) {
      return data ? moment(data).format('DD/MM/YYYY') : ''
    },
    formatarDataHora(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm') : ''
    },
    async abrirModalRastreabilidade(item) {
      this.modalRastreabilidade = item
      this.listaRastreabilidade = []
      
      this.$bvModal.show('modal-rastreabilidade')
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const response = await this.$http.get(`/api/protected/producao/pedido/item/getRastreabilidadeLote/${item.ID}`)
        this.listaRastreabilidade = response.data
      } catch (error) {
        console.error('Erro ao carregar rastreabilidade do lote:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Não foi possível carregar a rastreabilidade do lote')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalInfo(item) {
      this.modalDetalhes = item
      this.etiquetasEntradaResumo = []
      this.etiquetasEntrada = []
      this.etiquetasSaida = []
      
      this.$bvModal.show('modal-info')
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const [resumo, entrada, saida] = await Promise.all([
          this.$http.get(`/api/protected/producao/pedido/item/getEtiquetasEntradaResumo/${item.ID}`),
          this.$http.get(`/api/protected/producao/pedido/item/getEtiquetasEntrada/${item.ID}`),
          this.$http.get(`/api/protected/producao/pedido/item/getEtiquetasSaida/${item.ID}`)
        ])
        
        this.etiquetasEntradaResumo = resumo.data
        this.etiquetasEntrada = entrada.data
        this.etiquetasSaida = saida.data
      } catch (error) {
        console.error('Erro ao carregar detalhes do pedido:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Não foi possível carregar os detalhes do pedido')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onReabrirTerminalSaida(item) {
      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente reabrir o terminal de saída para este pedido?', {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, Reabrir',
          cancelTitle: 'Cancelar',
          centered: true
        })

        if (confirm) {
          await this.$http.post('/api/protected/producao/pedido/reabrirSaida', {
            pedidoId: item.ID,
            login: window.localStorage.getItem('login')
          })
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Terminal de saída reaberto')
          this.pesquisar()
        }
      } catch (error) {
        console.error('Erro ao reabrir terminal saída:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    },
    async onReabrirTerminalEntrada(item) {
      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente reabrir o terminal de entrada para este pedido?', {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, Reabrir',
          cancelTitle: 'Cancelar',
          centered: true
        })

        if (confirm) {
          await this.$http.post('/api/protected/producao/pedido/reabrirEntrada', {
            pedidoId: item.ID,
            login: window.localStorage.getItem('login')
          })
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Terminal de entrada reaberto')
          this.pesquisar()
        }
      } catch (error) {
        console.error('Erro ao reabrir terminal entrada:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'pedidos_producao.xlsx'
      })
    },
    exportarHtml() {
      printHtmlReport({
        reportTitle: 'Relatório de Pedidos de Produção',
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        printedBy: window.localStorage.getItem('nome') || window.localStorage.getItem('login') || '—'
      })
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'pedidos_producao.csv'
      })
    },
    exportarExcelDetalhe(rows, tipo) {
      exportExcelXlsx({
        rows,
        columns: this.fieldsEtiquetas,
        filename: `detalhe_${tipo.toLowerCase()}_pedido_${this.modalDetalhes.ID}.xlsx`,
        sumKey: 'PESO'
      })
    },
    exportarCsvDetalhe(rows, tipo) {
      exportCsv({
        rows,
        columns: this.fieldsEtiquetas,
        filename: `detalhe_${tipo.toLowerCase()}_pedido_${this.modalDetalhes.ID}.csv`
      })
    },
    exportarHtmlDetalhe(rows, tipo) {
      printHtmlReport({
        reportTitle: `Detalhe de ${tipo} - Pedido ${this.modalDetalhes.ID}`,
        rows,
        columns: this.fieldsEtiquetas,
        printedBy: window.localStorage.getItem('nome') || window.localStorage.getItem('login') || '—',
        footerTotals: [
          { key: 'PESO', formatter: v => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '0,000' },
          { key: 'PECAS_CAIXA' }
        ]
      })
    },
    exportarExcelRastreabilidade() {
      exportExcelXlsx({
        rows: this.listaRastreabilidade,
        columns: this.fieldsRastreabilidade,
        filename: `rastreabilidade_lote_pedido_${this.modalRastreabilidade.ID}.xlsx`,
        sumKey: 'PESO'
      })
    },
    exportarCsvRastreabilidade() {
      exportCsv({
        rows: this.listaRastreabilidade,
        columns: this.fieldsRastreabilidade,
        filename: `rastreabilidade_lote_pedido_${this.modalRastreabilidade.ID}.csv`
      })
    },
    exportarHtmlRastreabilidade() {
      printHtmlReport({
        reportTitle: `Rastreabilidade do Lote - Pedido ${this.modalRastreabilidade.ID}`,
        rows: this.listaRastreabilidade,
        columns: this.fieldsRastreabilidade,
        printedBy: window.localStorage.getItem('nome') || window.localStorage.getItem('login') || '—',
        footerTotals: [
          { key: 'PESO', formatter: v => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '0,000' },
          { key: 'PECAS_CAIXA' }
        ]
      })
    }
  },
  mounted() {
    if (this.TIPO_SITUACAO) {
      this.situacoesSelecionadas = this.TIPO_SITUACAO.split('-')
    }
    this.pesquisar()
    setTimeout(() => {
      this.$refs.dt1?.focus()
    }, 300)
  }
}
</script>

<style scoped>
.badge-orange {
  background-color: #fd7e14;
  color: white;
}

.text-orange {
  color: #fd7e14 !important;
}

.bg-orange {
  background-color: #fd7e14 !important;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 4px 6px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 2px 6px !important;
  color: #4a5568;
  font-size: 0.8rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

/* Premium Modal Styles */
.modal-premium-wrapper {
  background-color: #f8fafc;
}

.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15);
}

.modal-label-premium {
  display: block;
  text-transform: uppercase;
  font-size: 0.65rem;
  font-weight: 700;
  color: #718096;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  display: flex;
  align-items: center;
  border-left: 4px solid #667eea;
  padding-left: 10px;
}

.table-details-premium {
  font-size: 0.75rem;
}

.table-details-premium thead th {
  background-color: #f1f5f9 !important;
  color: #475569;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.65rem;
  padding: 8px 12px !important;
  border-top: none !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.table-details-premium tbody td {
  padding: 6px 12px !important;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9 !important;
}

.table-details-premium tr:hover {
  background-color: #f8fafc !important;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/views/producao/pedidoproducao/PedidoProducaoListagem.vue